import { Controller } from 'stimulus';
import dataLayer from '../helpers/dataLayer';

const KEY_ESCAPE = 27;

class SurveyController extends Controller {
  connect() {
    document.addEventListener('keyup', (e) => {
      if (e.keyCode === KEY_ESCAPE && document.querySelector('body').classList.contains('survey-open')) {
        this.toggleSurvey();
      }
    });
  }

  updateArrows() {
    const totalSteps = this.stepTargets.length - 1;
    const currentStep = this.getCurrentStep();
    const currentStepNumber = parseInt(currentStep.dataset.step, 10);

    this.arrowsTarget
      .classList
      .toggle('is-visible', currentStepNumber > 0);

    this.arrowsTarget
      .querySelector('[data-next]')
      .classList
      .toggle('is-hidden', totalSteps === currentStepNumber);
  }

  updateProgressBar() {
    const totalSteps = this.stepTargets.length - 1;
    const currentStep = this.getCurrentStep();
    const currentStepNumber = parseInt(currentStep.dataset.step, 10);

    this.progressBarTarget.classList.toggle('is-visible', currentStepNumber > 0);
    this.progressTarget.style.width = `${(100 / totalSteps) * currentStepNumber}%`;
  }

  // eslint-disable-next-line class-methods-use-this
  toNextStep(currentStep, nextStep) {
    setTimeout(() => {
      dataLayer.event('Survey', 'step change');

      currentStep.removeAttribute('data-active');
      nextStep.setAttribute('data-active', '');

      this.updateProgressBar();
      this.updateArrows();
    }, 250);
  }

  toggleSurvey() {
    document.querySelector('body').classList.toggle('survey-open');
    this.overlayTarget.classList.toggle('is-open');
  }

  onNextPrevClick(e) {
    const currentStep = this.getCurrentStep();
    let nextStepNumber = parseInt(currentStep.dataset.step, 10) + 1;

    if (typeof e.currentTarget.dataset.prev !== 'undefined') {
      nextStepNumber = parseInt(currentStep.dataset.step, 10) - 1;
    }

    const nextStep = this.overlayTarget.querySelector(`[data-step="${nextStepNumber}"]`);

    this.toNextStep(currentStep, nextStep);
  }

  onAnswerChange(e) {
    const { currentStep, nextStep } = this.getCurrentAndNextStep(e.currentTarget);

    this.toNextStep(currentStep, nextStep);
  }

  onNextStepClick(e) {
    const { currentStep, nextStep } = this.getCurrentAndNextStep(e.currentTarget);

    this.toNextStep(currentStep, nextStep);
  }

  getCurrentStep() {
    return this.overlayTarget.querySelector('[data-active]');
  }

  getCurrentAndNextStep(target) {
    const currentStep = target.closest('[data-target="survey.step"]');
    const nextStepNumber = parseInt(currentStep.dataset.step, 10) + 1;
    const nextStep = this.overlayTarget.querySelector(`[data-step="${nextStepNumber}"]`);

    return { currentStep, nextStep };
  }
}

SurveyController.targets = [
  'step',
  'arrows',
  'overlay',
  'progress',
  'progressBar',
];

export default SurveyController;
